import * as React from 'react'
import { AppointmentsButton } from './AppointmentsButton'
import { AppointmentsPopover } from './AppointmentsPopover'
import { usePopoverState } from './hooks'
import { AppointmentsPopoverContentProps } from './typing'

export const Appointments: React.FC<AppointmentsPopoverContentProps> = (
  props,
) => {
  const popoverState = usePopoverState()

  return (
    <>
      <AppointmentsButton {...popoverState} entityId={props.entityId} />
      <AppointmentsPopover {...popoverState} {...props} />
    </>
  )
}
Appointments.displayName = 'Appointments'
